import template from './oth.html';
import controller from './oth.controller';
import './oth.scss';

let OthComponent = {
  bindings: {},
  template,
  controller
};

export default OthComponent;



// WEBPACK FOOTER //
// ./src/app/pages/oth/oth.component.js